export default __webpack_public_path__ + "static/media/default-app.183164e6.svg";